import React from "react";

export const Star = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M8 1L10.163 5.27926L15 6.11147L11.5 9.52074L12.326 14L8 11.7793L3.674 14L4.5 9.52074L1 6.11147L5.837 5.27926L8 1Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
